import React from 'react';

import { Page } from '@tager/web-components';

import Layout from '@/layout';
import NotFound from '@/modules/NotFound';

function NotFoundPage() {
  return (
    <Page title="Страница не найдена">
      <Layout>
        <NotFound />
      </Layout>
    </Page>
  );
}

export default NotFoundPage;
